import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import { motion } from "framer-motion";

const faqData = [
  {
    question: "Qual a diferença entre o Plano Light e o Elite?",
    answer: "O Plano Light usa conexão via QR Code, ideal para começar rápido. O Elite usa a API Oficial da Meta, garantindo risco zero de banimento e 99.9% de estabilidade. Ambos incluem agentes ilimitados e IA.",
  },
  {
    question: "Posso trocar de plano depois?",
    answer: "Sim! Você pode fazer upgrade do Light para o Elite a qualquer momento. O valor será calculado de forma proporcional ao período restante.",
  },
  {
    question: "Quantos atendentes posso ter?",
    answer: "Ilimitados! Em ambos os planos você pode adicionar toda sua equipe sem pagar por cabeça. Um preço fixo, time ilimitado.",
  },
  {
    question: "O Plano Light tem risco de banimento?",
    answer: "O Light tem risco baixo quando usado corretamente, seguindo boas práticas de atendimento. Para operações críticas ou alto volume, recomendamos o Elite com risco zero garantido pela API Oficial Meta.",
  },
  {
    question: "Quais formas de pagamento são aceitas?",
    answer: "Cartão de crédito, PIX, boleto e transferência. Para planos anuais, parcelamento em até 12x.",
  },
  {
    question: "Como funciona o cancelamento?",
    answer: "Nossos planos são cobrados anualmente. Seus dados ficam disponíveis por 30 dias após o cancelamento para exportação.",
  },
];

const FAQSection = () => {
  return (
    <section id="faq" className="py-16 md:py-24 relative" aria-labelledby="faq-heading">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-surface-card/20 to-transparent" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-10 md:mb-16"
        >
          <div className="inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full glass-card mb-4 md:mb-6">
            <HelpCircle size={16} className="md:w-[18px] md:h-[18px] text-cyber-cyan" />
            <span className="text-xs md:text-sm text-muted-foreground">Tire suas dúvidas</span>
          </div>
          <h2 id="faq-heading" className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-display font-bold mb-4 md:mb-6">
            Perguntas{" "}
            <span className="text-gradient-zavvi">Frequentes</span>
          </h2>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqData.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="glass-card rounded-xl md:rounded-2xl border-0 overflow-hidden"
              >
                <AccordionTrigger className="px-4 md:px-6 py-4 md:py-5 hover:no-underline hover:bg-muted/50 text-left">
                  <span className="text-foreground font-medium text-sm md:text-base pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="px-4 md:px-6 pb-4 md:pb-5">
                  <p className="text-body-text text-xs md:text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        {/* Bottom CTA */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mt-10 md:mt-16 text-center"
        >
          <p className="text-muted-foreground text-sm mb-3 md:mb-4">
            Ainda tem dúvidas?
          </p>
          <a
            href="#contato"
            className="inline-flex items-center gap-2 text-cyber-cyan hover:text-cyber-cyan/80 font-medium transition-colors text-sm md:text-base"
          >
            Falar com um especialista →
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
